var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7376_11182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2681 22.1167C29.2681 22.1167 29.2681 22.3042 29.2681 24.3449C29.335 26.3285 28.2358 28.325 25.9712 29.8348C21.5785 32.7632 14.4648 32.751 10.0822 29.8075C7.83749 28.2998 6.74465 26.3155 6.80286 24.3449C6.80287 22.5191 6.80287 22.0894 6.80287 22.0894L29.2681 22.1167Z",
    fill: "#BED4DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.55903,
    cy: 9.55903,
    r: 9.55903,
    transform: "matrix(0.83205 -0.5547 0.830139 0.557556 2.14648 21.8213)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2559 25.5265L24.5407 16.8267",
    stroke: "#E0EAED",
    strokeWidth: 1.07405,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3423 20.0762C30.3423 20.0762 30.3423 20.2637 30.3423 22.3044C30.4093 24.2879 29.31 26.2845 27.0454 27.7942C22.6527 30.7227 15.539 30.7104 11.1565 27.7669C8.91171 26.2593 7.81887 24.275 7.87708 22.3044C7.87708 20.4785 7.87709 20.0489 7.87709 20.0489L30.3423 20.0762Z",
    fill: "#CCDDE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.55903,
    cy: 9.55903,
    r: 9.55903,
    transform: "matrix(0.83205 -0.5547 0.830139 0.557556 3.2207 19.7803)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3301 23.4854L25.6149 14.7856",
    stroke: "#E0EAED",
    strokeWidth: 1.07405,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2681 15.9156C29.2681 15.9156 29.2681 16.1031 29.2681 18.1438C29.335 20.1273 28.2358 22.1239 25.9712 23.6336C21.5785 26.562 14.4648 26.5498 10.0822 23.6063C7.83749 22.0986 6.74465 20.1144 6.80286 18.1438C6.80287 16.3179 6.80287 15.8883 6.80287 15.8883L29.2681 15.9156Z",
    fill: "#BED4DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.55903,
    cy: 9.55903,
    r: 9.55903,
    transform: "matrix(0.83205 -0.5547 0.830139 0.557556 2.14648 15.6201)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2559 19.3253L24.5407 10.6255",
    stroke: "#E0EAED",
    strokeWidth: 1.07405,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1197 12.9082C27.1197 12.9082 27.1197 13.0957 27.1197 15.1365C27.1866 17.12 26.0873 19.1165 23.8227 20.6263C19.4301 23.5547 12.3164 23.5425 7.9338 20.599C5.68906 19.0913 4.59621 17.1071 4.65443 15.1365C4.65443 13.3106 4.65443 12.8809 4.65443 12.8809L27.1197 12.9082Z",
    fill: "#CCDDE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.55903,
    cy: 9.55903,
    r: 9.55903,
    transform: "matrix(0.83205 -0.5547 0.830139 0.557556 0 12.6128)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10742 16.318L22.3923 7.61816",
    stroke: "#E0EAED",
    strokeWidth: 1.07405,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2681 9.90091C29.2681 9.90091 29.2681 10.0884 29.2681 12.1291C29.335 14.1126 28.2358 16.1092 25.9712 17.6189C21.5785 20.5474 14.4648 20.5352 10.0822 17.5916C7.83749 16.084 6.74465 14.0997 6.80286 12.1291C6.80287 10.3032 6.80287 9.87361 6.80287 9.87361L29.2681 9.90091Z",
    fill: "#CCDDE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.55903,
    cy: 9.55903,
    r: 9.55903,
    transform: "matrix(0.83205 -0.5547 0.830139 0.557556 2.14648 9.60498)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2559 13.3106L24.5407 4.61084",
    stroke: "#E0EAED",
    strokeWidth: 1.07405,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7376_11182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPill);
export default __webpack_public_path__ + "static/media/icon_pill.856cfdc1bfea12c2152fac60f1fe107d.svg";
export { ForwardRef as ReactComponent };